import { graphql } from "react-relay";

/////////
// GQL //
/////////

export const fragments = {
  user: graphql`
    fragment EventTeam_user on User {
      chromeExtensionFlagsErrorable {
        ...TutorialTeamSharedCalendar_flagsErrorable
      }
    }
  `,
  org: graphql`
    fragment EventTeam_org on Org {
      id
      ...EventSummaryTime_org
      id
      experiments
      domains
      primaryOrgCalendar
      userTeams {
        __typename
        ... on TeamList {
          list {
            id
            teamId
            teamCalendarId
            teamName
            createdBy {
              value
            }
            teamMembers {
              person {
                __typename
                id
                primaryCalendarId
                isYou
                userId
                profile {
                  givenName
                  familyName
                  externalImageUrl
                }
              }
            }
            invitedMembers {
              person {
                __typename
                id
                primaryCalendarId
                isYou
                userId
                profile {
                  givenName
                  familyName
                  externalImageUrl
                }
              }
            }
            settings {
              __typename
              ... on TeamSettings {
                manageTeamCalendar
              }
            }
          }
        }
      }
    }
  `,
  eventParent: graphql`
    fragment EventTeam_eventParent on EventParent
    @argumentDefinitions(calendarId: { type: "String!" }) {
      id
      externalEventId
      events {
        ...AutopilotFormSaveOnEdit_event @arguments(calendarId: $calendarId)
        ...EventSummary_event @arguments(calendarId: $calendarId)
        ...EventSmartHoldInfo_event @arguments(calendarId: $calendarId)
        ...EventPeople_event
        ...EventSummaryTime_event
        calendarIds
        isAllDay
        isClockwiseEvent
        locked
        organizerPerson {
          ... on Person {
            emails
          }
        }
        annotatedEvent {
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              subjectType
              subjectValue
              value
              active
            }
          }
        }
        eventKey {
          id
          calendarIds
          externalEventId
          hashedCalendars
          orgId
        }
        startTime {
          millis
          dateOrDateTime
          timeZone
        }
        endTime {
          millis
        }
        title
        attendees {
          displayName
          urnValue
        }
        organizer {
          urnValue
        }
      }
    }
  `,
  smartHoldEventInfo: graphql`
    fragment EventTeam_smartHoldEventInfo on SmartHoldEventInfo {
      isTeamCalendarSyncEvent
      originEvent {
        title
        isAllDay
        calendarIds
        eventKey {
          externalEventId
        }
        organizer {
          displayName
          urnValue
        }
        startTime {
          millis
          dateOrDateTime
        }
        endTime {
          millis
          dateOrDateTime
        }
        organizerPerson {
          __typename
          ... on Person {
            __typename
            primaryEmail
            emails
            isYou
            userId
            isUser
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
      }
    }
  `,
};

export const query = graphql`
  query EventTeamQuery($orgRelayId: ID!, $eventParentRelayId: ID!, $calendarId: String!) {
    viewer {
      user {
        ...EventTeam_user
      }
    }
    org: node(id: $orgRelayId) {
      ... on Org {
        ...EventTeam_org
      }
    }
    eventParent: node(id: $eventParentRelayId) {
      ... on EventParent {
        ...EventTeam_eventParent @arguments(calendarId: $calendarId)
      }
    }
  }
`;
